// Neutral grey placeholder as an inline data-URI (no network, can't 404, no
// "running-man" silhouette). Used as the <img> fallback for spots that aren't
// a person photo (club logos, agency/trophy images, etc.) so a missing image
// shows a plain grey box matching the app's muted style — replacing both the
// dead via.placeholder.com service and the player.png running-man.
//
// For PERSON photos prefer the grey-initials <PlayerAvatar> instead.
export const GREY_PLACEHOLDER =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48">' +
      '<rect width="48" height="48" fill="#F3F4F6"/></svg>'
  );

export default GREY_PLACEHOLDER;
